import AllocationDetailsCard from "./AllocationDetailsCard";

export default AllocationDetailsCard;
